export const SageTabs = Object.freeze({
    DESCUENTOS: 'descuentos',
    DIRECCIONES: 'direcciones',
    PEDIDOS: 'pedidos',
    CONTACTOS: 'contactos',
})


